<template>
    <div style="padding:30px;">
        <div v-if="authroized">
            <div style="color:orangered">来源1</div>
            <div v-for="l in list" style="margin-bottom:20px;">
                <div v-html="l"></div>
            </div>

            <div style="color:orangered">来源2</div>
            <div v-for="l in list2" style="margin-bottom:20px;">
                <div v-html="l"></div>
            </div>
        </div>

        <div v-if="!authroized">
            <input v-model="password" type="password"/>
            <button @click="viewList()">查看</button>
        </div>
    </div>
</template>

<script>

export default{
    data(){
        return{
            authroized:false,
            list:[],
            list2:[],
            password:"",
        }
    },
    mounted(){

    },
    methods:{
        viewList(){
            if(this.password == ""){
                alert("Please input the password");
                return;
            }
            this.$http.get("https://www.dctechonline.cn:8018/api/email/auth/"+this.password).then( res=>{
                if("OK" == res.data){
                    this.authroized = true;
                    this.loadEmails();
                }
                else{
                    alert('Error password')
                }
            });


            
        },
        loadEmails(){
            this.$http.get("https://www.dctechonline.cn:8018/api/email").then( res=>{
                console.log(res.data);
                this.list = res.data;
            })

            this.$http.get("https://adabk2.chinacloudsites.cn/api/email").then( res=>{
                console.log(res.data);
                this.list2 = res.data;
            })
        }
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// emails.vue?5fd1fce6